import {config as numberColumnConfig} from '../../common/NumberColumn';

const prop = 'rA';
export const id = 'reviewerAssignments';

export const config = (labels) => numberColumnConfig({fullId: id, label: labels.reviewerAssignments, prop});
